import {
  ENVIRONMENTS,
  REQUIREMENTS,
  RESULTS,
  RUNNER,
  SCHEDULE,
  SUTS,
  TEST_CONFIG,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'
import {
  FaDesktop,
  FaFileAlt,
  FaPlay,
  FaServer
} from 'react-icons/fa'
import { FiCrosshair } from 'react-icons/fi'
import {
  Icons,
  NavItemVerticalMini
} from '@eggplant/pattern-library'
import { RequirementsContextConsumer } from '@eggplant/context'

interface Props {
  base: string
  isCollapsed: boolean
}

const ControllerNav = ({
  base,
  isCollapsed
}: Props) => (
  <>
    <NavItemVerticalMini
      icon={<FaPlay aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[RUNNER]}
    >
      {renderLinkTo(base + '/' + RUNNER)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<Icons.Results aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[RESULTS]}
    >
      {renderLinkTo(base + '/' + RESULTS)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaFileAlt aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[TEST_CONFIG]}
    >
      {renderLinkTo(base + '/' + TEST_CONFIG)}
    </NavItemVerticalMini>
    <RequirementsContextConsumer>
      {
        ({ isRequirementsEnabled }) =>
          isRequirementsEnabled &&
            <NavItemVerticalMini
              icon={<FiCrosshair aria-hidden />}
              isCollapsed={isCollapsed}
              label={routeLabels[REQUIREMENTS]}
            >
              {renderLinkTo(base + '/' + REQUIREMENTS)}
            </NavItemVerticalMini>
      }
    </RequirementsContextConsumer>
    <NavItemVerticalMini
      icon={<Icons.ScheduleManagement aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[SCHEDULE]}
    >
      {renderLinkTo(base + '/' + SCHEDULE)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaDesktop aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[SUTS]}
    >
      {renderLinkTo(base + '/' + SUTS)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaServer aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[ENVIRONMENTS]}
    >
      {renderLinkTo(base + '/' + ENVIRONMENTS)}
    </NavItemVerticalMini>
  </>
)

export default ControllerNav
